import React from 'react';
import { useSetLocale, useLocaleState } from 'react-admin';
import { Button, Menu, MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { availableLanguages, setLanguage } from '../i18n';

export const LanguageSwitcher = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const setLocale = useSetLocale();
  const [locale] = useLocaleState();
  
  // Fallback если React Admin locale не работает
  const currentLocale = locale || localStorage.getItem('locale') || 'ru';

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (newLocale: string) => {
    // Сохраняем в localStorage
    setLanguage(newLocale);
    
    // Пытаемся обновить через React Admin если доступно
    try {
      setLocale(newLocale);
    } catch (error) {
      console.log('React Admin setLocale not available, using manual refresh');
      // Если React Admin не может переключить, перезагружаем страницу
      window.location.reload();
    }
    
    handleClose();
  };

  const currentLanguage = availableLanguages.find(lang => lang.locale === currentLocale);

  const getFlag = (locale: string) => {
    switch (locale) {
      case 'ru': return '🇷🇺';
      case 'en': return '🇺🇸';
      case 'pt': return '🇧🇷';
      default: return '🌐';
    }
  };

  return (
    <>
      <Button
        color="inherit"
        onClick={handleClick}
        startIcon={<LanguageIcon />}
        sx={{ 
          textTransform: 'none',
          minWidth: '120px',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
          }
        }}
      >
        {getFlag(currentLocale)} {currentLanguage?.name || 'Language'}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {availableLanguages.map((language) => (
          <MenuItem
            key={language.locale}
            onClick={() => handleLanguageChange(language.locale)}
            selected={currentLocale === language.locale}
          >
            <ListItemIcon sx={{ minWidth: '30px !important' }}>
              {getFlag(language.locale)}
            </ListItemIcon>
            <ListItemText primary={language.name} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
